/// <reference path="../../ng-services/chat.service.ts"/>

import { Attachment, ChatConversationMessage } from '../../models/chat';
import { LightboxService } from '../../ng-services/lightbox.service';

(function () {
    class ChatMessageAttachmentGalleryComponent {
        static $inject = ['LightboxService'];

        public message!: ChatConversationMessage;
        public attachments!: Attachment[];

        constructor(private lightboxService: LightboxService) {}

        handleClick(clickedAttachment: Attachment) {
            const mapToLightboxItem = (attachment: any) => ({
                owner: this.message.owner,
                ...attachment,
                ...attachment.urls,
                id: attachment.hash,
            });

            const lightboxItems = this.attachments.map((a) => mapToLightboxItem(a));

            return this.lightboxService.openGallery(lightboxItems, mapToLightboxItem(clickedAttachment));
        }
    }

    angular.module('tradersyard').component('tyChatMessageAttachmentGallery', {
        // language=HTML
        template: `
        <div class="chat_message_attachment_gallery">
           <div class="chat_message_attachment_gallery__item" ng-repeat="att in $ctrl.attachments track by att.id" ng-click="$ctrl.handleClick(att)">
             <div class="chat_message_attachment_gallery__thumb_wrapper"><img ng-src="{{att.urls.thumb_url}}" alt="{{att.name}}"></div>
           </div>
        </div>
    `,
        bindings: {
            attachments: '<',
            message: '<',
        },
        controller: ChatMessageAttachmentGalleryComponent,
    });
})();
